module.exports = __webpack_public_path__ + "img/wf-background.23a63443.png";